import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-logo-only-header',
    templateUrl: './logo-only-header.component.html',
    styleUrls: ['./logo-only-header.component.css']
})
export class LogoOnlyHeaderComponent {
    @Input()
    secondaryLogoUrl: string;
}
